import { Link, useNavigate,  } from "react-router-dom";
import { seedFeatureDBRoute } from "../../api/routes";
import axios from "../../api/axios";
import { toast } from "react-toastify";
import { useState, useEffect } from "react";
import RangeSlider from "../../components/forms/RangeSlider/RangeSlider";
import SingleMachineCameraFeed from "../../components/FeatureControls/custom-control-components/claw-camera-feeds/SingleMachineCameraFeed";
import "./ClawDebugTools.scss";

function Home() {
    const navigate = useNavigate();
    
    // Left machine controls
    const [xPercLeft, setXPercLeft] = useState(50);
    const [yPercLeft, setYPercLeft] = useState(50);
    
    // Right machine controls
    const [xPercRight, setXPercRight] = useState(50);
    const [yPercRight, setYPercRight] = useState(50);

const connectToClawMachine = (machineID) => {
    axios
    .post('claw/connect', { machineID: parseInt(machineID), withCredentials:true})
    .then(function (response) {
        console.log(response);
        toast.success(`Machine ${machineID} connected`);
    })
    .catch(function (error) {
        toast.error('Error - ' + (error.response?.data?.message || error.message));
    })
}
const disconnectClawMachine = (machineID) => {
    axios
    .post('claw/disconnect', { machineID: parseInt(machineID), withCredentials:true})
    .then(function (response) {
        console.log(response);
        toast.success(`Machine ${machineID} disconnected`);
    })
    .catch(function (error) {
        toast.error('Error - ' + (error.response?.data?.message || error.message));
    })
}
const clawGetVersions = (machineID) => {
    axios
    .post('claw/get-versions', { machineID: parseInt(machineID), withCredentials:true})
    .then(function (response) {
        console.log(response);
        toast.success(`Machine ${machineID} versions fetched`);
    })
    .catch(function (error) {
        toast.error('Error - ' + (error.response?.data?.message || error.message));
    })
}
const clawAutomatePlayTest = (machineID, xPerc, yPerc) => {
    axios
    .post('claw/automate_play_action', {xPerc:xPerc, yPerc:yPerc, machineID:parseInt(machineID), withCredentials:true})
    .then(function (response) {
        console.log(response);
        toast.success(`Machine ${machineID === 1 ? 'LEFT' : 'RIGHT'} moved successfully!`);
    })
    .catch(function (error) {
        toast.error('Error - ' + (error.response?.data?.message || error.message));
    })
}
const clawResetMachine = (machineID) => {
    axios
    .post('claw/reboot_machine', {machineID:parseInt(machineID), withCredentials:true})
    .then(function (response) {
        console.log(response);
        toast.success('Machine '+ machineID+' Soft Reset - Success');
    })
    .catch(function (error) {
        toast.error('Error - ' + (error.response?.data?.message || error.message));
    })
}
const clawRebootMachine = (machineID) => {
    axios
    .post('claw/reboot_machine', {machineID:parseInt(machineID), withCredentials:true})
    .then(function (response) {
        console.log(response);
        toast.success('Machine '+ machineID+' Rebooting - Please Wait');
    })
    .catch(function (error) {
        toast.error('Error - ' + (error.response?.data?.message || error.message));
    })
}

  return (
      <div className="claw-debug-container">
          <div className="claw-debug-header">
              <h1>CLAW MACHINE DEBUG TOOLS</h1>
          </div>
          
          {/* Two Column Layout */}
          <div className="claw-machines-container">
              
              {/* LEFT MACHINE COLUMN */}
              <div className="claw-machine-column left-machine">
                  <h2>LEFT MACHINE (ID: 1)</h2>
                  <div className="claw-machine-body">
                      <div className="claw-camera-pane">
                          <SingleMachineCameraFeed machineID={1} machineName="Left" />
                      </div>
                      <div className="claw-controls-section">
                          <div className="claw-local-controls">
                              <button className="standard-button" onClick={() => connectToClawMachine(1)}>CONNECT LEFT</button>
                              <button className="standard-button" onClick={() => disconnectClawMachine(1)}>DISCONNECT LEFT</button>
                              <button className="standard-button" onClick={() => clawGetVersions(1)}>GET VERSIONS LEFT</button>
                          </div>
                      <RangeSlider
                          label={'X Percentage'}
                          labelNote={''}
                          setFunc={(newVal) => { setXPercLeft(newVal) }}
                          min={0}
                          max={100}
                          value={xPercLeft}
                          showCurrentValue={true}
                      />
                      
                      <RangeSlider
                          label={'Y Percentage'}
                          labelNote={''}
                          setFunc={(newVal) => { setYPercLeft(newVal) }}
                          min={0}
                          max={100}
                          value={yPercLeft}
                          showCurrentValue={true}
                      />
                      
                      <div className="claw-button-group">
                          <button 
                              className="standard-button" 
                              onClick={() => clawAutomatePlayTest(1, xPercLeft, yPercLeft)}
                          >
                              Play LEFT Claw Move
                          </button>
                          
                          <button 
                              className="standard-button" 
                              onClick={() => clawResetMachine(1)}
                          >
                              SOFT RESET LEFT MACHINE
                          </button>
                          
                          <button 
                              className="warning-button" 
                              onClick={() => clawRebootMachine(1)}
                          >
                              HARD REBOOT LEFT MACHINE
                          </button>
                      </div>
                      </div>
                  </div>
              </div>

              {/* RIGHT MACHINE COLUMN */}
              <div className="claw-machine-column right-machine">
                  <h2>RIGHT MACHINE (ID: 2)</h2>
                  <div className="claw-machine-body">
                      <div className="claw-camera-pane">
                          <SingleMachineCameraFeed machineID={2} machineName="Right" />
                      </div>
                      <div className="claw-controls-section">
                          <div className="claw-local-controls">
                              <button className="standard-button" onClick={() => connectToClawMachine(2)}>CONNECT RIGHT</button>
                              <button className="standard-button" onClick={() => disconnectClawMachine(2)}>DISCONNECT RIGHT</button>
                              <button className="standard-button" onClick={() => clawGetVersions(2)}>GET VERSIONS RIGHT</button>
                          </div>
                      <RangeSlider
                          label={'X Percentage'}
                          labelNote={''}
                          setFunc={(newVal) => { setXPercRight(newVal) }}
                          min={0}
                          max={100}
                          value={xPercRight}
                          showCurrentValue={true}
                      />
                      
                      <RangeSlider
                          label={'Y Percentage'}
                          labelNote={''}
                          setFunc={(newVal) => { setYPercRight(newVal) }}
                          min={0}
                          max={100}
                          value={yPercRight}
                          showCurrentValue={true}
                      />
                      
                      <div className="claw-button-group">
                          <button 
                              className="standard-button" 
                              onClick={() => clawAutomatePlayTest(2, xPercRight, yPercRight)}
                          >
                              Play RIGHT Claw Move
                          </button>
                          
                          <button 
                              className="standard-button" 
                              onClick={() => clawResetMachine(2)}
                          >
                              SOFT RESET RIGHT MACHINE
                          </button>
                          
                          <button 
                              className="warning-button" 
                              onClick={() => clawRebootMachine(2)}
                          >
                              HARD REBOOT RIGHT MACHINE
                          </button>
                      </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  );
}

export default Home;
